import React, { Fragment } from 'react'

import Alert from 'admin/components/common/Alert'
import PageFrame from 'admin/components/common/PageFrame'
import Text from 'admin/components/common/Text'
import { LoginState } from 'admin/redux/ducks/login'
import Loader from 'components/ui/Loader'
import { AdminTypes, AlertLevels } from 'types/'

const SelectOrgAccountView: React.FunctionComponent<SelectOrgAccountViewProps> = (props) => {
  const { login: { data, isLoading, error }, onSelect, onReset } = props
  let alert = error
  const organizations = data && data.organizations && data.organizations.length > 0 ? data.organizations : []
  if (!error) {
    const orgAccountCount = organizations.reduce((count, org) => count + org.orgAccounts.length, 0)
    if (orgAccountCount === 0) {
      alert = {level: AlertLevels.ERROR, message: 'NO_ORGANIZATIONS_FOUND_FOR_PERSON'}
    }
  }

  return (
    <PageFrame childContainerClassName="l-height--100%">
      <div className="l-flex--centered-child">
        <div className="Box l-max-width--30 l-max-height--100% u-overflow-scroll--y">
          <div className="l-position__relative">
            {alert
              ? <>
                  <Alert alert={alert} className="l-margin--b" />
                  <p className="l-align--center l-margins--v">
                    <button onClick={onReset}><Text>general.back</Text></button>
                  </p>
                </>
              : <>
                  <h2><Text>label.login_select_account_title</Text></h2>
                  {organizations.map((organization) =>
                    <Fragment key={organization.orgNumber}>
                      <h3>{organization.orgName}</h3>
                      <ul className="SelectList l-margin--b">
                        {organization.orgAccounts && organization.orgAccounts.map(orgAccount => (
                          <li
                            key={`account_${  orgAccount.orgAccountId}`}
                            className="SelectList__item"
                            onClick={() => onSelect(orgAccount.orgAccountId, organization.orgNumber, organization.administratorType)}
                          >
                            {orgAccount.orgAccountName}
                          </li>
                        ))}
                      </ul>
                    </Fragment>,
                  )}
                  <div className="l-align--center">
                    <button onClick={onReset}><Text>general.cancel</Text></button>
                  </div>
                </>
            }
            <Loader visible={isLoading} local />
          </div>
        </div>
      </div>
    </PageFrame>
  )
}

type SelectOrgAccountViewProps = {
  login: LoginState,
  onSelect: (orgAccountId: string, orgNumber: string, administratorType: AdminTypes) => any,
  onReset: () => void,
}

export default SelectOrgAccountView